export const UPLOADED_FILES_FORMIK_KEY = 'uploadedFilesInformation';
export const DESCRIPTION_ATTRIBUTE_FILE_FORMIK_KEY = 'description';
export const TYPE_ID_ATTRIBUTE_FILE_FORMIK_KEY = 'fileTypeId';
export const FILE_ATTRIBUTE_FILE_FORMIK_KEY = 'file';
export const DOCUMENT_PATH_FILE_FORMIK_KEY = 'documentPath';
